import { useMemo } from "react";

export const usePeriodOptions = ({ t, priceList }) => {
  const options = useMemo(() => {
    if (!priceList) return [];
    return Object.keys(priceList).map((value) => ({
      label: t(`premium:period.${value}_months`),
      value: +value,
    }));
  }, [t, priceList]);
  return options;
};
